import { useContext } from 'react';
import { DemoContext } from '../context';

const useResponsiveTools = () => useContext(DemoContext);

export default useResponsiveTools;
